// Contracts.
import { createContract, extract } from '@exonet/jsonapi-fetcher/lib/resources';
import { searchAction } from '@exonet/jsonapi-fetcher/lib/search';
import { searchDomainHandles } from '../contracts';

/**
 * Get data from the store state and map it to properties this component can use.
 *
 * @param {Object} _api The current store state.
 * @param {string} handleId The ID of the  to fetch.
 * @param {Array} defaultOptions The default options.
 * @param {boolean} mounting If true then the component is still fetching data.
 * @param {Object} filterInvoices The handles to filter out from the options.
 *
 * @return {Object} The mapped state to properties available in the component.
 */
const mapStateToProps = (
  { api, app },
  { handleId = null, defaultOptions = [], fetchState: { mounting }, excludeCompanyHandles },
) => {
  const multiple = Array.isArray(handleId);
  const selected = extract(createContract('domain_handles'), api)
    .all('domain_handles', (item) => (multiple ? handleId.includes(item.id) : item.id === handleId))
    .toOptions(excludeCompanyHandles);

  const allOptions = [...defaultOptions, ...selected];

  const base = {
    customerId: app.customer.id,
    loading: mounting,
    defaultOptions: allOptions,
  };

  if (handleId === null) {
    return { ...base, defaultValue: null };
  }

  return { ...base, defaultValue: multiple ? selected : selected?.[0] };
};

const mapDispatchToProps = (dispatch, { excludeCompanyHandles }) => ({
  searchAction: async (value, customerId) => {
    const controls = {
      filter: {},
      page: { number: 1, size: 30 },
      search: { value },
    };

    return dispatch(
      searchAction(searchDomainHandles(controls, customerId, excludeCompanyHandles)).get(),
    );
  },
});

export default [mapStateToProps, mapDispatchToProps];
